module.exports = __webpack_public_path__ + "static/senior-5-13ddea84983267e3ec02e6861b8cd7c8.png";